import _ from 'lodash';
import React, { Component } from 'react';
import './styles.scss';
import { EmmaAppWebViewDeepLink as DeepLink } from '../../../../types/configTypes';
import { getCardViewState } from '../../../../modules/myPrivileges/selectors/myPrivilegesSelector';
import { resolveLocalizedText, resolvePublicAssets } from '../../../../utils';
import { CardViewState } from '../../../../modules/myPrivileges/reducers';
import { openDisclaimer } from '../../../../modules/emma-common/actions';
import { goto } from '../../../../actions/historyActions';
import {
  getPoPartnerServiecs,
  getCwpPartnerServiecs,
  isCWP,
} from '../../../home/selectors/serviceSelectors';
import { EmmaPartnerService } from '../../../home/types/EmmaPartnerService';
import { getHaveReadNewFeatures } from '../../../../selectors/sideBarItemSelectors';
import { getDefaultRedDotMaxCount } from '../../../../selectors/configSelectors';
import { NewFeaturepiRes } from '../../../../types/sideBarItemTypes';
import { pushHaveReadNewFeatureSingle } from '../../../../actions/sideBarItemActions';
import { getLanguage } from '../../../../selectors/userSelectors';
import { addCorpWebIndicator } from '../../../../utils/emmaUrlConverter';
import iconArrowRight from '../../../../assets/images/arrow@3x.png';
import { select } from '../../../../stores';
import { getValidToken, isApp } from '../../../../utils';
import { getToken } from '../../../../selectors/authSelectors';
import { getCorpWebIndicatorConfig } from '../../../emma-webview/selectors/webviewSelector';
import {
  getGaPagePath,
  handleGaError,
} from '../../../../utils/generalGaEventAnalytics';

export interface CardViewProps {
  cardViewId?: string;
  isLocked?: boolean;
  title?: string;
  subtitle?: string;
  icon?: any;
  lockedIcon?: any;
  deepLink?: DeepLink;
  deepLinkLock?: DeepLink;
  onClickCardView: (
    isLocked: boolean,
    enableNewFeatureDot: boolean,
    deepLinkLock?: DeepLink,
    newFeatures?: EmmaPartnerService,
  ) => void;
  reducerSubName?: string;
  newFeatures?: EmmaPartnerService;
  haveReadNewFeatures?: Array<NewFeaturepiRes>;
  redDotMaxCount: number;
  cardDeeplink?: string;
  cardFaceType: string;
  cardImage: string;
}

export class CardView extends Component<CardViewProps, CardViewState> {
  constructor(props: any = {}) {
    super(props);
    this.onClickToGatc = this.onClickToGatc.bind(this);
  }

  componentDidMount() {}

  onClickToGatc(cardViewId: any, title?: string) {
    const tcWindow: any = window;
    const token = select(getToken);
    const aToken = getValidToken(token);
    const screenName = `${getGaPagePath()}#privileges`;
    // ga#MP6
    try {
      tcWindow.dataLayer.push({
        event: 'betterMeServiceCardClicked',
        serviceName: title,
        serviceId: cardViewId,
        screenName: screenName,
        AXAID: aToken,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // if (!isApp()) {
      //   tcWindow.tC.event.servicesClick(tcWindow, {
      //     serviceName: title,
      //     serviceId: cardViewId,
      //     page: screenName,
      //     AXAID: aToken,
      //   });
      // }
    } catch (e) {
      handleGaError(e);
    }
  }

  isShowRedDot() {
    const { haveReadNewFeatures, redDotMaxCount, newFeatures, cardViewId } =
      this.props;
    const NewFeaturesResult = _.find(
      haveReadNewFeatures,
      (item: { id: string }) => item.id === cardViewId,
    );
    const clickCount = NewFeaturesResult ? NewFeaturesResult['clickCount'] : 0;
    const enableInNewFeatureDot = clickCount < redDotMaxCount ? true : false;
    const isShowRedDot = !!(
      newFeatures &&
      newFeatures.id &&
      newFeatures.enableNewFeatureDot &&
      enableInNewFeatureDot
    );
    return isShowRedDot;
  }

  render() {
    const {
      cardViewId,
      isLocked,
      title,
      subtitle,
      icon,
      lockedIcon,
      deepLinkLock,
      onClickCardView,
      newFeatures,
      cardDeeplink,
      cardFaceType,
      cardImage,
    } = this.props;

    let link

    switch (cardViewId) {
      case 'cdp': {
        link = 'emma-cms?path=/myPrivilegesIntro/my-privileges-intro-beontrack'
        break;
      }
      case 'preventionstage': {
        link =
          'emma-cms?path=/myPrivilegesIntro/critical-illness-prevention-services';
        break;
      }
      case 'treatmentandrehabilitationstage': {
        link =
          'emma-cms?path=/myPrivilegesIntro/treatment-and-rehabilitation-services';
        break;
      }
      default: {
          link = `emma-my-privileges/details-view?myprivileges_details_id=${cardViewId}`
          break
      }
    }

    const enableNewFeatureDot = this.isShowRedDot();
    return (
      <div className="myprivileges-card-view-container">
        <a
          onClick={() => {
            if (!cardDeeplink) {
              this.onClickToGatc(cardViewId, title);
              onClickCardView(
                isLocked || false,
                enableNewFeatureDot,
                deepLinkLock,
                newFeatures,
              );
              !isLocked && goto(link);
            } else {
              this.onClickToGatc(cardViewId, title);
              window.open(cardDeeplink);
            }
          }}
          data-enable-ga
          data-ga-type="button"
          data-ga-text={title}
        >
          <div className="myprivileges-card-view">
            {enableNewFeatureDot && (
              <div className="myprivileges-card-view__new-feature-dot"></div>
            )}
            {cardFaceType === 'default' && (
              <div className="myprivileges-card-view__top-container">
                <div className="myprivileges-card-view__icon-container">
                  {!isLocked && (
                    <img className="myprivileges-card-view__icon" src={icon} />
                  )}
                  {isLocked && (
                    <img
                      className="myprivileges-card-view__icon"
                      src={lockedIcon}
                    />
                  )}
                </div>
              </div>
            )}
            {cardFaceType === 'image' && (
              <div className="myprivileges-card-view__img-container">
                <img
                  className="myprivileges-card-view__img"
                  src={cardImage}
                  alt="bg-img"
                />
              </div>
            )}
            <div className="myprivileges-card-view__bottom-container">
              <div className="myprivileges-card-view__title">
                {title}
                {cardFaceType === 'image' && <img src={iconArrowRight} />}
              </div>
              {cardFaceType === 'default' && (
                <div className="myprivileges-card-view__subtitle">
                  {subtitle}
                </div>
              )}
            </div>
          </div>
        </a>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const lang = getLanguage(state);
    const cardViewState = getCardViewState(
      state,
      ownProps.cardViewId,
      ownProps.reducerSubName,
    );
    // Card view id
    const partnerServices = isCWP(state)
      ? getCwpPartnerServiecs(state)
      : getPoPartnerServiecs(state);
    const NewFeaturesResult = _.find(
      partnerServices,
      (item: { id: string }) => item.id === ownProps.cardViewId,
    );
    const haveReadNewFeature = getHaveReadNewFeatures(state);
    const redDotMaxCount =
      NewFeaturesResult && NewFeaturesResult.redDotMaxCount
        ? NewFeaturesResult.redDotMaxCount
        : getDefaultRedDotMaxCount(state);
    const cardFaceType = cardViewState.cardFaceType || 'default';
    return {
      title: cardViewState.subtitle
        ? resolveLocalizedText(cardViewState.subtitle)
        : '',
      subtitle: cardViewState.subjectDesc
        ? resolveLocalizedText(cardViewState.subjectDesc)
        : '',
      icon: resolvePublicAssets(cardViewState.icon).replace('.png', '@3x.png'),
      lockedIcon: resolvePublicAssets(cardViewState.lockedIcon).replace(
        '.png',
        '@3x.png',
      ),
      deepLink: cardViewState.deepLink,
      deepLinkLock: cardViewState.deepLinkLock,
      newFeatures: NewFeaturesResult,
      haveReadNewFeatures: haveReadNewFeature
        ? haveReadNewFeature.features
        : undefined,
      redDotMaxCount: redDotMaxCount,
      cardDeeplink: cardViewState.cardDeeplink
        ? addCorpWebIndicator({
            url: cardViewState.cardDeeplink.replace(`\${language}`, lang),
            ...getCorpWebIndicatorConfig(state),
          })
        : '',
      cardFaceType: cardFaceType,
      cardImage: resolvePublicAssets(cardViewState.cardImage || ''),
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onClickCardView: (
        isLocked: boolean,
        enableNewFeatureDot: boolean,
        deepLinkLock?: any,
        newFeatures?: EmmaPartnerService,
      ) => {
        if (newFeatures && newFeatures.id && enableNewFeatureDot) {
          dispatch(
            pushHaveReadNewFeatureSingle(
              newFeatures.id,
              1,
              newFeatures.redDotMaxCount,
            ),
          );
        }
        if (isLocked && deepLinkLock) {
          const { disclaimer } = deepLinkLock.query;
          if (disclaimer) {
            dispatch(openDisclaimer(disclaimer, {}, false));
          }
        }
      },
    };
  }
}
